//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    boss: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    background: {
      type: String,
      default: "#fbf3e7",
    },
  },
  computed: {
    index() {
      let num = Math.abs(this.value) * 100 || 0;
      return Math.ceil(num / 10);
    },
  },
};
